/**
 * App version and build for the account menu (V2-037), from the build-time env the Bugsnag
 * setup already reads. Either can be missing on a local build; the menu then says "not set".
 */
export interface AppVersionInfo {
  version: string | null;
  build: string | null;
}

export function appVersionInfo(env: Record<string, string | undefined> = process.env): AppVersionInfo {
  const version = env.REACT_APP_VERSION?.trim() || null;
  const sha = (env.REACT_APP_GIT_SHA || env.REACT_APP_GITHUB_COMMIT)?.trim() || null;
  return { version, build: sha ? sha.slice(0, 7) : null };
}
